// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1_zcI","cls2":"CreateSocialItemModal-cls2_fa3 CreateSocialItemModal-cls1_zcI"};